import { CourseCard } from "../CourseCard";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { courses } from "../../data/mock";
import { getRelatedCourses } from "../../lib/relatedCourses";

export const OtherCoursesSection = ({ currentCourseId }) => {
  // Раньше здесь были просто первые четыре курса массива — одни и те же
  // на каждой странице. Теперь подбор по категории и смежным темам.
  const current = courses.find(c => c.id === currentCourseId);
  const otherCourses = current
    ? getRelatedCourses(current, courses, 4)
    : courses.filter(c => !c.hidden).slice(0, 4);

  return (
    <section className="py-20 bg-[#F1EDE4]" data-testid="other-courses-section">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="course-eyebrow">
            Похожие курсы
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            <span className="ink-underline">Вам также может понравиться</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Расширьте свои навыки с нашими профессиональными курсами
          </p>
        </div>

        {/* Courses Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {otherCourses.map((course, index) => (
            <CourseCard key={course.id} course={course} index={index} testId={`other-course-card-${course.slug}`} />
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-10">
          <Link to="/courses">
            <Button 
              className="bg-teal-600 hover:bg-teal-500 text-white font-semibold px-8 py-6 text-lg rounded-xl transition-all group"
              data-testid="view-all-courses-btn"
            >
              Смотреть все курсы
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
